import { render, staticRenderFns } from "./gmxz.vue?vue&type=template&id=d5e765c0&scoped=true&"
import script from "./gmxz.vue?vue&type=script&lang=js&"
export * from "./gmxz.vue?vue&type=script&lang=js&"
import style0 from "./gmxz.vue?vue&type=style&index=0&id=d5e765c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e765c0",
  null
  
)

export default component.exports